import Ajv8, {type ErrorObject, type Options} from '@wix/dm-ajv'
import _ from 'lodash'

export {ErrorObject, Options}

type Ajv8Type = InstanceType<typeof Ajv8.Ajv>

export {Ajv8Type}

const createInstance = (ajvOptions: any = {}, formats: Options['formats'] = {}): Ajv8Type => {
    const instance = new Ajv8.Ajv2019(ajvOptions as any)
    Ajv8.formats(instance)
    _.forEach(formats, (formatSchema, formatName) => {
        instance.addFormat(formatName, formatSchema!)
    })
    return instance
}

export {createInstance}
